import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import './ContentBlocks.css';

const ContentBlockHolder = (props) => (
  <div className={'content-block '+(props.dual?'dual':'single')+' '+(props.triple?'triple':null)+' '+props.className}>
    <div className="container">
      {props.children}
    </div>
  </div>
)

ContentBlockHolder.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ContentBlockHolder);



// WEBPACK FOOTER //
// ./src/components/ContentBlocks/ContentBlockHolder.js